import { render, staticRenderFns } from "./ArtMsglist.vue?vue&type=template&id=8d08e688&scoped=true&"
import script from "./ArtMsglist.vue?vue&type=script&lang=ts&"
export * from "./ArtMsglist.vue?vue&type=script&lang=ts&"
import style0 from "./ArtMsglist.vue?vue&type=style&index=0&id=8d08e688&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d08e688",
  null
  
)

export default component.exports